import { connect } from 'react-redux';
import * as accountSelectors from 'redux-modules/resume/selectors.js';
import * as accountActions from 'redux-modules/resume/actions.js';
import * as authActions from 'redux-modules/auth/actions.js';
import Editor from './Editor';

function mapStateToProps(state) {
  return {
    syncing: accountSelectors.selectSyncState(state),
    syncErrors: accountSelectors.selectSyncError(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onDelete: (data, failCallback) => dispatch(accountActions.deleteProfile(data, failCallback)),
    onLogout: () => dispatch(authActions.logout())
  };
}

export default connect(mapStateToProps,mapDispatchToProps)(Editor);
